import * as Sentry from '@sentry/astro';

// Errors only. No tracesSampleRate = no performance traces (they burn Sentry quota).
Sentry.init({
  dsn: import.meta.env.PUBLIC_SENTRY_DSN,
  environment: import.meta.env.MODE || 'production',

  // Enable debug mode in development
  debug: import.meta.env.MODE === 'development',
});
